export const mapToCssModules = (cssModule: Array<string | undefined> = []): string => {
    return cssModule.filter(Boolean).join(' ');
  };